// Mock ticket store (localStorage). No backend / no payment.
// A "ticket" = { eventId, type: 'inPerson' | 'online', purchasedAt }

const KEY = "whoolive_tickets";

export const getPurchased = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
};

export const grantAccess = (eventId, type = "online") => {
  const list = getPurchased();
  if (!list.some((t) => t.eventId === eventId && t.type === type)) {
    list.push({ eventId, type, purchasedAt: new Date().toISOString() });
    localStorage.setItem(KEY, JSON.stringify(list));
  }
};
